import TimelinePageAdmin from './TimelinesPageAdmin';

export default TimelinePageAdmin;
